/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Injectable, TemplateRef } from '@angular/core';

@Injectable()
export class GmcErrorsRegistry {
  defaultErrorTemplates = new Map<string, TemplateRef<any>>();
  extraErrorTemplates = new Map<string, TemplateRef<any>>();
  public addErrorTemplate(error: string, templateRef: TemplateRef<any>, isDefault: boolean) {
    this[isDefault ? 'defaultErrorTemplates' : 'extraErrorTemplates'].set(error, templateRef);
  }
  public getErrorTemplate(error: string): TemplateRef<any> | undefined {
    return this.extraErrorTemplates.get(error) || this.defaultErrorTemplates.get(error);
  }
}
